import React, { useState, useEffect } from "react";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";

const TestPage = () => {
  const [data, setData] = useState();

  const testConnection = (username: string, password: string): void => {
    // assuming username and password are user input
    const url = ""; // api url

    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok"); // throwing error if its not OK, we can use response code as well for more specfic error
        sessionStorage.setItem("username", username); // setting user inputed username into sessionStorage to use later on
        sessionStorage.setItem("password", password); // setting user inputed password into sessionStorage to use later on
        window.location.href = ""; // redirect url
        return response.json();
      })
      .then((response) => console.log(response))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    const url = "";
    const username = sessionStorage.getItem("username");
    const password = sessionStorage.getItem("password");

    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        sessionStorage.removeItem("username"); // removing username from sessionStorage to avoid data leak
        sessionStorage.removeItem("password"); // removing password from sessionStorage to avoid data leak
        return response.json();
      })
      .then((response) => {
        setData(response); // set data to local state
      });
  }, []);

  return (
    <div>
      <JsonView src={data} />
    </div>
  );
};

export default TestPage;
